import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import { Modal } from 'reactstrap';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { confirmAlert } from 'react-confirm-alert';

// constants
import { FILES_URL } from '../Common/constant';
import LocalStrings from '../../languages';
import { showError, showSuccess } from '../Common/alertmessage';

// actions
import {
  showSidebar,
  updateActiveTab,
  updateAppuser,
  logout
} from '../../actions';
import {
  setIsVSPopup,
  setVSPopupContent
} from '../Common/vertical-sliding-popup/actions';
import { openChat } from '../userschat/actions';
import { openAttendeeProfile } from '../attendee/actions';

// files
import closelogo from '../../assets/img/icons/closemenu.svg';
import defaultUser from '../../assets/img/placeholders/NoCourse.svg';
import login from '../../assets/img/icons/login.svg';
import noimg from '../../assets/img/placeholders/NoImg.svg';
import { setHSPopup } from '../Common/horizontal-sliding-popup/actions';
import appIcons from '../Common/appIcons';

const SideBar = props => {
  const {
    session,
    isMobile = false,
    deviceSize,
    eventTabs,
    userDetails,
    webviewDetails,
    userChatData,
    componentHeight = false,
    sidenavoutsideClicked = false,
    siteControl
  } = props;
  const location = useLocation();
  const [showModal, setShowModal] = useState(false);
  var webviewUrl = '';

  // console.log('eventTabs:- ', eventTabs);
  // console.log('routes:- ', props.routes);

  let userImg = userDetails?.profileurl
    ? `${FILES_URL}/${userDetails?.profileurl}?api_key=${session.apiKey}`
    : '';

  useEffect(() => {
    const path = location.pathname;
    props.setHSPopup({ show: false, component: '', data: {} });
    updateActiveTab(path);
  }, [location]);

  useEffect(() => {
    if (sidenavoutsideClicked) closeNav();
    return () => {};
  }, [sidenavoutsideClicked]);

  if (webviewDetails?.websiteurl && !_.isEmpty(webviewDetails.websiteurl)) {
    webviewUrl = webviewDetails.websiteurl;
  }

  const closeNav = () => {
    props.showSidebar(false);
  };

  const updateActiveTab = path => {
    const split = path.split('/');
    props.updateActiveTab(split[1]);

    // Close the vertical popup section on session change
    props.setIsVSPopup(false);
    props.setVSPopupContent('');

    // Close the Chat details secions and attendee details
    props.openChat({ show: false, user: {} });
    props.openAttendeeProfile({ show: false, value: {} });
  };

  const handleNetworkStatusUpdate = () => {
    let dataObj = {
      isnetworking: 1,
      appuserid: userDetails.appuserid,
      eventid: userDetails.eventid
    };
    let formRes = JSON.parse(userDetails?.responses);
    _.map(formRes, field => {
      if (field.name == 'isnetworking') {
        field.value = true;
      }
    });
    dataObj.responses = JSON.stringify(formRes);
    props.updateAppuser(session, dataObj, response => {
      if (response.success) {
        setShowModal(false);
        showSuccess(LocalStrings.profile_alert_success);
      } else {
        showError(LocalStrings.kSomethingWrong);
      }
    });
  };

  // creates the links that appear in the top menu
  const createTopLinks = () => {
    if (siteControl === 'restrict') return <></>;

    var routesNew = _.filter(props.routes, list => {
      return list.display && list.position === 'top' && list.section === 'side';
    }); // custom check is login not display in sidebar

    return routesNew.map((prop, key) => {
      var selected = _.includes(props.location.pathname, prop.path);
      var menuClass = `${
        selected ? 'top-selected-menu' : 'top-unselected-menu'
      }`;

      if (session?.eventid == 1780731138296391 && prop.path === '/agenda')
        return <></>;

      return (
        <a
          key={`key_${key}`}
          className={menuClass}
          // to={`${prop.path}`}
          href={`#${prop.path}`}
          onClick={() => updateActiveTab(prop.path)}
        >
          <div className="top-menu-item" onClick={isMobile ? closeNav : null}>
            <div className="top-icon-content">
              <div className="top-icon-container">
                <div className="top-menu-icons">{prop.icon}</div>
              </div>
            </div>
            <div className="top-menu-name">{prop.name}</div>
          </div>
        </a>
      );
    });
  };

  // creates the links that appear in the left menu
  const createLinks = () => {
    if (siteControl === 'restrict') return <></>;

    var routesNew = _.filter(props.routes, function(list) {
      return list.display && list.position === 'leftside';
    }); // custom check is login not display in sidebar

    return routesNew.map((prop, key) => {
      var selected = _.includes(props.location.pathname, prop.path);
      var menuClass = `nav-link menu-link ${
        selected ? 'selected-menu' : 'unselected-menu'
      }`;

      return (
        <li
          key={`key_${key}`}
          className={`nav-item mb-1${
            deviceSize.isMobile && deviceSize.width < 991 && key === 0
              ? ' mt-2'
              : ''
          }`}
          onClick={isMobile ? closeNav : null}
        >
          {prop.path === '/chat' && !userDetails?.isnetworking ? (
            <div
              className={menuClass}
              style={{ cursor: 'pointer' }}
              onClick={() => setShowModal(true)}
            >
              <div className="menu-icons">{prop.icon}</div>
              {deviceSize.width > 991 && deviceSize.width <= 1199 ? (
                ''
              ) : (
                <>
                  {' '}
                  <div className="menu-name">{prop.name}</div>
                </>
              )}
            </div>
          ) : prop.path === '/chat' &&
            userDetails?.isnetworking &&
            userChatData?.totalUnread &&
            userChatData?.totalUnread > 0 ? (
            <>
              <a
                className={`${menuClass}${
                  deviceSize.isMobile && deviceSize.width < 991 && key === 0
                    ? ' mt-2'
                    : ''
                }`}
                // to={`${prop.path}`}
                href={`#${prop.path}`}
                onClick={() => updateActiveTab(prop.path)}
                style={{ position: 'relative' }}
              >
                <div className="menu-icons">{prop.icon}</div>
                {deviceSize.width > 991 && deviceSize.width <= 1199 ? (
                  ''
                ) : (
                  <>
                    {' '}
                    <div className="menu-name">{prop.name}</div>
                  </>
                )}
                <div
                  className="custom-unread-count"
                  style={userChatData?.totalUnread > 99 ? { width: 22 } : {}}
                >
                  {userChatData?.totalUnread > 99
                    ? '99+'
                    : userChatData?.totalUnread}
                </div>
              </a>
            </>
          ) : prop.path === '/webview' && webviewUrl != '' ? (
            <a
              className={`${menuClass}${
                deviceSize.isMobile && deviceSize.width < 991 && key === 0
                  ? ' mt-2'
                  : ''
              }`}
              href={webviewUrl}
              // onClick={() => updateActiveTab(prop.path)}
              target={'_blank'}
            >
              <div className="menu-icons">{prop.icon}</div>
              {deviceSize.width > 991 && deviceSize.width <= 1199 ? (
                ''
              ) : (
                <>
                  {' '}
                  <div className="menu-name">{prop.name}</div>
                </>
              )}
            </a>
          ) : (
            <a
              className={`${menuClass}${
                deviceSize.isMobile && deviceSize.width < 991 && key === 0
                  ? ' mt-2'
                  : ''
              }`}
              // to={`${prop.path}`}
              href={`#${prop.path}`}
              onClick={() => updateActiveTab(prop.path)}
            >
              <div className="menu-icons">{prop.icon}</div>
              {deviceSize.width > 991 && deviceSize.width <= 1199 ? (
                ''
              ) : (
                <>
                  {' '}
                  <div className="menu-name">{prop.name}</div>
                </>
              )}
            </a>
          )}
        </li>
      );
    });
  };

  const _handleLogout = () => {
    confirmAlert({
      title: LocalStrings.kLogoutText,
      message: `${LocalStrings.logout_confirm_subtext}?`,
      buttons: [
        {
          label: LocalStrings.button_yes,
          onClick: () => {
            props.logout(session);

            props.history.push({
              pathname: '/overview'
            });
          }
        },
        {
          label: LocalStrings.kNoTextLC,
          onClick: () => {}
        }
      ]
    });
  };

  var guInitial = `${_.toUpper(LocalStrings.kGuestUser[0])}${_.toUpper(
    LocalStrings.kGuestUser[6]
  )}`;
  var nameInitial = '';
  if (userDetails.firstname && userDetails.lastname) {
    nameInitial = `${_.toUpper(userDetails.firstname[0])}${_.toUpper(
      userDetails.lastname[0]
    )}`;
  }

  return (
    <>
      <div
        // className="sidebar-container  scrollbar-hide-no-maxheight"
        className={`sidebar-container ${
          !deviceSize.isMobile && deviceSize.width > 991
            ? 'background-white'
            : ''
        }`}
        style={deviceSize.isMobile ? {} : { border: 'none' }}
      >
        <div className="blank-sidebar-top">
          {isMobile ? (
            <>
              <div className="closebtn-container">
                <div className="avatar">
                  {/* {userDetails?.profileurl ? (
                  <img
                    alt="..."
                    src={`${FILES_URL}/${userDetails?.profileurl}?api_key=${session.apiKey}`}
                  />
                ) : (
                  <>
                    <img alt="..." src={defaultUser} />
                  </>
                )} */}
                  {userImg == '' ? (
                    <div className="profile-name-initial-4040">
                      <div className="letter-padding">
                        {!_.isEmpty(userDetails) ? (
                          <>
                            <span>{nameInitial}</span>
                          </>
                        ) : (
                          <>
                            <span>{guInitial}</span>
                          </>
                        )}
                      </div>
                    </div>
                  ) : (
                    <>
                      <LazyLoadImage
                        alt={'Image'}
                        effect="blur"
                        placeholder={
                          <img
                            src={noimg}
                            className="attendee-user-img"
                            alt="lazy load placeholder on error"
                          />
                        }
                        className="attendee-user-img"
                        src={userImg}
                        onError={e => {
                          e.target.onerror = null;
                          e.target.src = noimg;
                        }}
                      />
                    </>
                  )}
                </div>
                <img
                  onClick={e => closeNav()}
                  src={closelogo}
                  className="closebtn"
                />
              </div>
              <div className="sidebar-username">
                <div className="ml-1">
                  <span className="custom-text1-medium">
                    {userDetails?.username}
                  </span>
                </div>
                <div className="mt-1 mb-2" onClick={isMobile ? closeNav : null}>
                  <a
                    href="#/myprofile"
                    // to="myprofile"
                  >
                    <span className="custom-button-primary-sm-tags">
                      {LocalStrings.kEditProfile.toUpperCase()}
                    </span>
                  </a>
                </div>
              </div>
              <div className="top-menu-section">
                {siteControl !== 'restrict' && createTopLinks()}
                <a className="top-unselected-menu" onClick={_handleLogout}>
                  <div
                    className="top-menu-item"
                    onClick={isMobile ? closeNav : null}
                  >
                    <div className="top-icon-content">
                      <div className="top-icon-container">
                        <div className="top-menu-icons">
                          {appIcons.logoutIcon}
                        </div>
                      </div>
                    </div>
                    <div className="top-menu-name">
                      {LocalStrings.kLogoutText}
                    </div>
                  </div>
                </a>
              </div>
              {/* <div className="divider2" /> */}
            </>
          ) : (
            ''
          )}
        </div>
        <nav
          className="navbar scrollbar-hide-no-maxheight"
          // style={
          //   componentHeight
          //     ? { height: deviceSize.height - 320 + 25 }
          //     : isMobile
          //     ? { height: deviceSize.height - 192 }
          //     : { height: '100%' }
          // }
          style={{
            alignItems: 'start',
            height: componentHeight
              ? deviceSize.height - 320 + 25
              : isMobile
              ? deviceSize.height - 192
              : '100%'
          }}
        >
          <ul
            className="navbar-nav w-100"
            style={
              !deviceSize.isMobile && deviceSize.width > 991
                ? { padding: 0 }
                : {}
            }
          >
            {createLinks()}
          </ul>
        </nav>

        {/* ----------- common NW consent modal popup ------------- */}
        {showModal ? (
          <Modal
            className="preview-lesson"
            isOpen={showModal}
            size="md"
            centered
          >
            <div className="modal-header">
              <div className="modal-title custom-text2-medium-primary">
                {LocalStrings.kGDPRConsentTitleText}
              </div>
              <button
                aria-label="Close"
                className="close"
                data-dismiss="modal"
                type="button"
                onClick={() => setShowModal(false)}
              >
                <span aria-hidden={true}>×</span>
              </button>
            </div>

            <div className="modal-body">
              <div className="d-flex">
                <div className="col-10 mb-1" style={{ marginLeft: '-10px' }}>
                  <div className="custom-text1-normal">
                    {LocalStrings.kGDPRConsentText}
                  </div>
                </div>
                <div className="col-2">
                  <label className="switch">
                    <input
                      type="checkbox"
                      onChange={handleNetworkStatusUpdate}
                    />
                    <span className="slider round"></span>
                  </label>
                </div>
              </div>
            </div>
            <div
              className="modal-footer"
              style={{ backgroundColor: '#faeecf' }}
            >
              <div
                className="custom-text1-medium-notes"
                style={{ marginRight: '1.5rem' }}
              >
                <div className="">
                  <span>{LocalStrings.kGDPRNoteText}</span>
                </div>
              </div>
            </div>
          </Modal>
        ) : (
          ''
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state, ownProps) => {
  // console.log('state.activeTab: ', state.activeTab);
  // console.log('sidebar webview: ', state.webviewDetails);

  return {
    session: state.session,
    show: state.showSidebar,
    activeTab: state.activeTab,
    eventTabs: state.eventTabs,
    userDetails: state.userDetails,
    webviewDetails: state.webviewDetails,
    deviceSize: state.deviceSize,
    userChatData: state.unreadChatCountReducer,
    siteControl: state.siteControlReducer
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      showSidebar,
      updateActiveTab,
      setIsVSPopup,
      setVSPopupContent,
      openChat,
      openAttendeeProfile,
      updateAppuser,
      setHSPopup,
      logout
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SideBar);
